export default __webpack_public_path__ + "static/media/mac.4679ab67.jpeg";